import React, { useState } from 'react';

const UserBonusList: React.FC<{ manualBonusUsers: any[]; values: any; setValues: any; disabled?: boolean }> = ({
  manualBonusUsers,
  values,
  setValues,
  disabled,
}) => {
  const [showDisabled, setShowDisabled] = useState(true);

  const handleAmountChange = (id: string, amount: string) => {
    const updated = (manualBonusUsers || []).map((ub: any) =>
      ub.manualBonusUserId === id ? { ...ub, bonusAmount: amount } : ub,
    );
    setValues({ ...values, manualBonusUsers: updated });
  };

  const handleEnabledChange = (id: string, isActive: boolean) => {
    const updated = (manualBonusUsers || []).map((ub: any) => (ub.manualBonusUserId === id ? { ...ub, isActive } : ub));
    setValues({ ...values, manualBonusUsers: updated });
  };

  const filteredUsers =
    !disabled && showDisabled ? manualBonusUsers : manualBonusUsers.filter((u) => u.isActive !== false);

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-between align-items-center">
        <label className="fw-bold mx-3">User Bonuses</label>
        {!disabled && (
          <div className="form-check form-switch me-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="showDisabledToggle"
              checked={showDisabled}
              onChange={(e) => setShowDisabled(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="showDisabledToggle">
              Show All
            </label>
          </div>
        )}
      </div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Bonus Amount</th>
            {!disabled && <th className="text-center">Enabled</th>}
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((item) => (
            <tr key={item.manualBonusUserId} className={disabled || item.isActive === false ? 'table-secondary' : ''}>
              <td>{`${item.user.firstName} ${item.user.lastName}`}</td>
              <td>
                <input
                  type="number"
                  className="form-control"
                  value={item.bonusAmount || ''}
                  onChange={(e) => handleAmountChange(item.manualBonusUserId, e.target.value)}
                  min={0}
                  step={0.01}
                  disabled={disabled || item.isActive === false}
                />
              </td>
              {!disabled && (
                <td className="text-center">
                  <input
                    type="checkbox"
                    checked={item.isActive !== false}
                    onChange={(e) => handleEnabledChange(item.manualBonusUserId, e.target.checked)}
                  />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserBonusList;
